__turbopack_context__.v({
  "className": "dvgULa_className",
  "variable": "dvgULa_variable",
});
